import store from "../../store";
import { computed } from "vue";
import { empty } from "../../../helpers";

export default function useMusic() {
  const defaultSong = "Golden";
  const defaultInterpret = "Harry Styles";
  const defaultActualTime = "1:44";
  const defaultEndTime = "3:28";

  // computed
  const song = computed(() => getComputedAttribute(defaultSong, "song"));
  const interpret = computed(() =>
    getComputedAttribute(defaultInterpret, "interpret")
  );
  const actualTime = computed(() =>
    getComputedAttribute(defaultActualTime, "actualTime")
  );
  const endTime = computed(() =>
    getComputedAttribute(defaultEndTime, "endTime")
  );

  /*
   *   Main methods
   */
  function changeTimeRange(event) {
    const product = store.getters["product/getProduct"];
    const value = event.target.value;
    let actualTimeSeconds, endTimeSeconds;
    // preset actual and end timeline by placeholder
    presetDateRange(product);

    endTimeSeconds = minutesToSeconds(product.attributes.endTime);

    actualTimeSeconds = Number((endTimeSeconds / 100) * value).toFixed(0);
    // update actual time
    product.attributes.actualTime = secondsToMinutes(actualTimeSeconds);

    store.commit("product/SET_RANGE", value);
  }

  function toggleTimeline(event) {
    const product = store.getters["product/getProduct"];
    const isChecked = event.target.checked;

    store.commit("product/SET_SHOW_TIMELINE", isChecked);

    if (!isChecked) {
      delete product.attributes.actualTime;
      delete product.attributes.endTime;
    } else {
      product.attributes.actualTime = defaultActualTime;
      product.attributes.endTime = defaultEndTime;
    }
  }

  function changeTimeTextInput() {
    const attributes = store.getters["product/getProduct"].attributes;
    const range = (
      (100 * totalSeconds(attributes.actualTime)) /
      totalSeconds(attributes.endTime)
    ).toFixed(2);

    store.commit("product/SET_RANGE", range);
  }

  function toggleQR(event) {
    store.commit("product/SET_SHOW_QR", event.target.checked);
  }

  /*
   *   Helper methods
   */
  function getComputedAttribute(defaultText, attribute) {
    const name = store.getters["product/getProduct"].attributes[attribute];

    return empty(name) ? defaultText : name;
  }

  function secondsToMinutes(seconds) {
    const divisorForMinutes = seconds % (60 * 60);
    const minutes = Math.floor(divisorForMinutes / 60);
    const divisorForSeconds = divisorForMinutes % 60;

    seconds = ("0" + divisorForSeconds).slice(-2);

    return minutes + ":" + seconds;
  }

  function minutesToSeconds(time) {
    const parts = time.split(":");

    return Number(parts[0]) * 60 + Number(parts[1]);
  }

  function presetDateRange(product) {
    const attributes = product.attributes;

    if (empty(attributes.endTime)) {
      attributes.endTime = defaultEndTime;
    }

    if (empty(attributes.actualTime)) {
      attributes.actualTime = defaultActualTime;
    }
  }

  function totalSeconds(time) {
    var parts = time.split(":");
    return parts[0] * 3600 + parts[1] * 60;
  }

  return {
    toggleQR,
    defaultActualTime,
    defaultEndTime,
    toggleTimeline,
    changeTimeRange,
    changeTimeTextInput,
    song,
    interpret,
    actualTime,
    endTime,
  };
}
